<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  stroke={color}
  stroke-width={strokeWidth}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 48 48"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <polygon
    class="a"
    points="11.361 38.149 24.779 36.491 24.779 41.701 40.487 34.419 42.5 21.336 37.705 21.336 38.889 6.299 8.578 10.976 11.183 20.744 5.5 20.744 11.361 38.149"
  /><line class="a" x1="11.5203" y1="25.0674" x2="16.4444" y2="25.0674" /><line
    class="a"
    x1="13.9824"
    y1="32.5"
    x2="13.9824"
    y2="25.0674"
  /><polyline
    class="a"
    points="31.556 32.5 31.556 25.067 36.48 32.5 36.48 25.067"
  /><path
    class="a"
    d="M17.6035,30.038a2.4621,2.4621,0,0,0,4.9241,0V27.53a2.4621,2.4621,0,1,0-4.9241,0Z"
  /><path
    class="a"
    d="M24.58,30.038a2.462,2.462,0,0,0,4.924,0V27.53a2.462,2.462,0,1,0-4.924,0Z"
  /><line class="a" x1="23.4212" y1="22.9326" x2="27.1375" y2="22.9326" /><line
    class="a"
    x1="23.4212"
    y1="15.5"
    x2="27.1375"
    y2="15.5"
  /><line class="a" x1="23.4212" y1="19.2163" x2="25.8442" y2="19.2163" /><line
    class="a"
    x1="23.4212"
    y1="15.5"
    x2="23.4212"
    y2="22.9326"
  /><polyline
    class="a"
    points="21.446 15.5 19.588 22.933 17.729 15.5 15.871 22.933 14.013 15.5"
  /><path
    class="b"
    d="M32.1288,19.2163a1.8582,1.8582,0,0,1,0,3.7163h-3.066V15.5h3.066a1.8582,1.8582,0,0,1,0,3.7163Z"
  /><line class="b" x1="32.1288" y1="19.2163" x2="29.0628" y2="19.2163" />
</svg>
